import { Box, Divider, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import PaperHeader from '../../../components/PaperHeader';
import VideoListDetails from '../../../components/VideoListDetails';
import SuggestedTasks from './SuggestedTasks';

import { post } from '../../../api';
import AdditionalResources from '../../../components/AdditionalResources';
import { useAuth } from '../../../hooks/useAuth';

import RenderContent from '../../../components/RenderContent';
import { PaperBox } from '../../../style/GlobalStyles';

function SolutionDetail({ sx = {}, show = false, solution = {}, updateSolution, setLoading, loading, ...other }) {
    const theme = useTheme();

    const createMarkup = (text) => {
        return { __html: text };
    };
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    const [hasPersonalProducts, setHasPersonalProducts] = useState(false);

    useEffect(() => {
        post('custom/checkUserHasPersonalProduct', { accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }).then((result) => {
            if (result.isSuccess && result.data === 'true') {
                setHasPersonalProducts(true);
            } else {
                setHasPersonalProducts(false);
            }
        });
    }, []);

    useEffect(() => {
        if (!solution.innerLoaded) {
            setLoading(true);

            post('custom/getSolutionDetails', { solutionId: solution.id, accountIds: userDetails.businessList?.map((item) => item.accountId) }).then((result) => {
                if (result.isSuccess) {
                    // solution.tasks = result.data.tasks;
                    updateSolution({ ...solution, tasks: result.data.tasks, resources: result.data.resources, innerLoaded: true });
                }

                setLoading(false);
            });
        }
    }, [solution.id]);

    const updateTask = (task) => {
        const tasks = solution.tasks.map((item) => {
            if (item.id === task.id) {
                return task;
            }
            return item;
        });
        updateSolution({ ...solution, tasks: tasks });
    };

    return (
        <PaperBox
            sx={{
                width: { xs: '100%' },
                height: { xs: '100%' },
                overflow: 'auto',
                position: 'relative',
            }}
        >
            <Box sx={{ minWidth: { md: '600px' } }}>
                <PaperHeader
                    headingText={solution?.name}
                    rightSideButton={null}
                    sx={{
                        background: 'none',
                    }}
                />
                <Divider
                    sx={{
                        m: '1rem 0',
                    }}
                />
                {/* <div className="description" dangerouslySetInnerHTML={createMarkup(solution.description)}></div> */}
                <RenderContent htmlString={solution.description} />
                {solution.tasks?.length > 0 && (
                    <Box
                        sx={{
                            marginTop: '1.5rem',
                        }}
                    >
                        <SuggestedTasks hasPersonalProducts={hasPersonalProducts} tasks={solution.tasks} updateTask={updateTask} />
                    </Box>
                )}
                {(solution.resources?.length > 0 || solution.videoLink) && (
                    <Box
                        sx={{
                            marginTop: '1.5rem',
                        }}
                    >
                        <Typography component={'h3'} variant="heading3" color={'text.primary'}>
                            Get the most out of Business Navigator
                        </Typography>
                        <Box
                            sx={{ display: 'flex' }}
                            flexDirection={{
                                xs: 'column',
                                sm: 'row',
                            }}
                            marginTop={'1rem'}
                        >
                            {solution.videoLink && <VideoListDetails url={solution.videoLink} />}
                            {solution.resources?.length > 0 && <AdditionalResources resources={solution.resources} />}
                        </Box>
                    </Box>
                )}
            </Box>
        </PaperBox>
    );
}

export default SolutionDetail;
